@if (userService.isProgramAdmin()) {
  <oes-collapsible-section
    [title]="'program.pre-qualification.message-developer' | translate"
    icon="./assets/icons/line-icons/shared/grey/message.svg"
    [isExpanded]="false"
  >
    <oes-program-message-window
      [participantOrganization]="participantOrganization()"
      [program]="program()"
      [stageOneApplicationId]="stageOneApplicationId()"
      [currentUser]="currentUser()"
      [displayConfiguration]="{ displayReceiverSender: false, displayMessagesList: false, displayStatusSelector: true, isEvaluationMessage: isEvaluationMessage() }"
      [customWindowStyles]="{ 'border': 'none' }"
      [programApplication]="programApplication()"
    />
  </oes-collapsible-section>
}
